export const trackingLCModification = {
  basePath: 'mybooking/modification-trip',
  changeTripLC: 'change-trip',
  summaryLC: 'timeline',
  flightSelectorLC: 'flights-select',
  stopovers: 'stopovers',
  error: 'error'
};
export const trackingModification = {
  basePath: 'mybooking/voluntary-changes-2',
  flightSelector: 'flights-selection',
  contactAirline: 'contact-airline',
  paxSelector: 'passengers-selection',
  search: 'travel-dates',
  depDate: 'departure-date',
  retDate: 'return-date',
  depRetDate: 'dep-ret-date',
  results: 'flights/results',
  noResults: 'error/no-results',
  datesNotAllowed: 'dates-not-allowed',
  estimatedPopup: 'total-estimated-price-info',
  itinerary: 'flights/itinerary',
  summary: 'flights/summary',
  searchExpired: 'search-expired',
  genericError: 'flights/error',
  funnelType: {
    totalPrice: 'total-price',
    estimatedPrice: 'estimated-price',
    totalFlexiExt: 'total-price-flexi-external',
    totalFlexiInt: 'total-price-flexi-internal',
    estimatedFlexiExt: 'estimated-price-flexi-external',
    estimatedFlexiInt: 'estimated-price-flexi-internal',
    autoCollectFree: 'free-auto-collect',
    autoCollectPaid: 'paid-auto-collect',
    xfaring: 'xfaring'
  }
};
export const funnelTypes = {
  lc: 'low-cost'
};